
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter, Mutation } from 'vuex-class';
import ContentPreview from '@/components/Editor/ContentPreview.vue';
import store from '@/store';
import { Product } from '@/types/product';
import { codemirror } from 'vue-codemirror-lite';
import ProductMetaDataInput from '@/components/Product/ProductMetaDataInput.vue';
import TwitterPreview from '@/components/Editor/TwitterPreview.vue';
import LinkedInPreview from '@/components/Editor/LinkedInPreview.vue';
import FacebookPreview from '@/components/Editor/FacebookPreview.vue';
import Editor from '@/components/Editor/Editor.vue';
require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/addon/edit/closetag');
require('codemirror/addon/edit/matchtags');

@Component({
  components: {
    ContentPreview,
    codemirror,
    Editor,
    ProductMetaDataInput,
    FacebookPreview,
    LinkedInPreview,
    TwitterPreview,
  },
})
export default class ProductEditor extends Vue {
  @Prop() id!: string;

  @Action('products/updateProduct') updateProduct!: Function;

  @Getter('products/product') product!: Product;

  @Mutation('products/setProductContent') setProductContent!: Function;
  @Mutation('products/setProductIntroText') setProductIntroText!: Function;
  @Mutation('products/setProductCostsText') setProductCostsText!: Function;
  @Mutation('products/setProductOtherText') setProductOtherText!: Function;

  dialog: boolean = false;
  isSaving: boolean = false;
  tabs: number = 0;
  toggleEditMode: number = 0;
  codemirrorOptions: object = {
    mode: 'htmlmixed',
    tabSize: 4,
    lineNumbers: true,
    lineWrapping: true,
    matchTags: true,
    closeTag: true,
    viewportMargin: Infinity,
  };

  isEditorValid: boolean = true;

  get productContent(): string | undefined | null {
    return this.product.content.content;
  }
  set productContent(value) {
    this.setProductContent(value);
  }
  get editorContent(): string {
    return this.product.content.content as string;
  }

  get productIntroText(): string | undefined | null {
    return this.product.content.intro_text;
  }
  set productIntroText(value) {
    this.setProductIntroText(value);
  }

  get productCostsText(): string | undefined | null {
    return this.product.content.costs_text;
  }
  set productCostsText(value) {
    this.setProductCostsText(value);
  }

  get productOtherText(): string | undefined | null {
    return this.product.content.other_text;
  }
  set productOtherText(value) {
    this.setProductOtherText(value);
  }

  async saveProduct() {
    this.isSaving = true;
    await this.updateProduct();
    this.isSaving = false;
  }

  onEditorBlur() {
    return (this.isEditorValid =
      this.editorContent !== '<p>&nbsp;</p>' && !!this.editorContent);
  }

  get imageExists(): boolean {
    return this.product.logo !== null;
  }

  get imageUrl(): string {
    const find =
      'https://s3.eu-west-2.amazonaws.com/cdn.alternativebusinessfunding.co.uk';
    const replace =
      'https://cdn.alternativebusinessfunding.co.uk/fit-in/360x360';
    return this.product.logo!.replace(find, replace);
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('products/getProduct', to.params.id);
    }
    next();
  }

  async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('products/getProduct', to.params.id);
    }
    next();
  }
}
